import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import {
  flipmeConnectAsync,
  flipmeGetInfoAsync,
  flipmeNFTWithdrawAsync
} from './FlipMeWallet.request';

import { ErrorToast } from '../../components';

export const flipmeConnect = createAsyncThunk(
  'flipmeConnect',
  async (
    {
      emailCode,
      twoFACode,
      step,
      setStep
    }: {
      emailCode: string;
      twoFACode: string;
      step: number;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      await flipmeConnectAsync({
        emailCode,
        twoFACode
      });

      setStep(step);

      dispatch(flipMeGetInfo());
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const flipMeGetInfo = createAsyncThunk('flipMeGetInfo', async () => {
  try {
    const { data } = await flipmeGetInfoAsync();

    return data;
  } catch (error: any) {
    ErrorToast(error.response.data.error);
  }
});

export const flipmeNFTWithdraw = createAsyncThunk(
  'flipmeNFTWithdraw',
  async (
    {
      userPackageId,
      step,
      setStep
    }: {
      userPackageId: number;
      step: number;
      setStep: Dispatch<SetStateAction<number>>;
    },
    { dispatch, getState }
  ) => {
    try {
      await flipmeNFTWithdrawAsync({
        userPackageId
      });

      setStep(step);

      // dispatch(flipMeGetInfo());
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);
